/**
 * «Open Remarks» asked from the table (the session summary's line «Game hints: N — open Remarks»): Studio is not
 * mounted there, so the wish waits here until the next StudioSurface takes it.
 */
let pending = false;
export function markRemarksOpenPending(): void { pending = true; }
export function takeRemarksOpenPending(): boolean {
  const was = pending;
  pending = false;
  return was;
}
